import { Component, EventEmitter, Input, Output } from '@angular/core';
import { get } from 'lodash';

import { EMMATableColumn } from './emma-table.types';

type SummaryCalc = 'avg' | 'sum';

@Component({
    selector: '[emma-table-summary-row]',
    templateUrl: './emma-table-summary-row.component.html',
    standalone: false
})
export class EMMATableSummaryRowComponent {
  @Input() hasActions = false;
  @Input() showCalc = false;
  @Input() calcSummary: SummaryCalc = 'sum';
  @Input() columns: EMMATableColumn[] = [];
  @Input() summaryCache: any = {};
  @Input() colorSummaryBtn? = 'inverse-emmadarkblue';

  @Output() $calc = new EventEmitter<SummaryCalc>();
  getProp = get;
}
